import type { SanityHardwareCardDocument, SanityPageBuilderProductRowSection, SanityPageBuilderSection } from "@ouster/shared";
import { ProductRowBlockView } from "~/features/blocks/inventory/product-row";
import { ProductCardView, type ProductCardViewProps } from "~/features/card/product-card";
import { type Props as AssetProps } from "~/features/craft/asset";
import { toCraftAsset } from "~/features/sanity/media";
import type { Mode, Theme } from "~/features/ui/get-theme-style";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderProductRowSection;
  };
};
type ProductRowViewProduct = Omit<ProductCardViewProps, "mode"> & {
  _id?: SanityHardwareCardDocument["_id"];
};
export function SanityProductRowSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const mode = (sectionSettings?.mode || "light") as Mode;
  const theme = (sectionSettings?.theme || "white") as Theme;
  const products = sectionContent.products?.map<ProductRowViewProduct>(product => ({
    _id: product._id,
    asset: toCraftAsset(product.productImage) as AssetProps["asset"],
    id: product._id,
    productCaption: product.productCaption,
    productHighlights: product.productHighlights,
    title: product.title,
    url: product.uri
  })) ?? [];
  return <ProductRowBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} getProductKey={(product, index) => product._id || index} hasTopDivider={sectionSettings?.hasTopDivider ?? true} mode={mode} products={products} renderProduct={(product, _index, productMode) => <ProductCardView mode={productMode} {...product} />} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={theme} />;
}